import { render, staticRenderFns } from "./NewsletterPreferencesSection.vue?vue&type=template&id=19fd7fc8&scoped=true&"
import script from "./NewsletterPreferencesSection.vue?vue&type=script&lang=js&"
export * from "./NewsletterPreferencesSection.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterPreferencesSection.vue?vue&type=style&index=0&id=19fd7fc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fd7fc8",
  null
  
)

export default component.exports